import React, { useEffect } from 'react';
import { get, isEmpty, isNil } from 'lodash';
import { Chip } from '@material-ui/core';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IntlShape, injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardTitle from 'containers/common/Card/CardTitle';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import TablePagination from '@material-ui/core/TablePagination';

import { translate } from 'containers/services/translate';
import messages from 'containers/ManagerPendingTreatementClaims/messages';
import {
  requestPendingTreatementClaims,
  requestSearchPendingTreatementClaims,
} from 'containers/ManagerPendingTreatementClaims/actions';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  setClaimNumber,
  setNotification,
  setTransactionId,
} from 'containers/AppContainer/actions';
import {
  makeSelectPendingTreatementClaims,
  makeSelectCountPendingTreatementClaims,
} from 'containers/ManagerPendingTreatementClaims/selectors';
import { ROW_PER_PAGE } from 'constants/global';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import SearchBar from 'containers/ManagerPendingTreatementClaims/SearchBar';
import {
  getLabelInboxe,
  getLabelSubInboxe,
} from 'containers/ManagerPendingTreatementClaims/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { COLORS } from 'constants/design';
import { setSelectedClaim } from 'containers/IdentificationPage/actions';
import {
  renderExpertiseTab,
  renderGlobalTab,
  renderInstanceTab,
  renderLegalProceedingTab,
  renderRegulationTab,
  renderTransactionTab,
} from 'containers/AppContainer/utils';
import { resetSagisInfoClaim } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  requestUnlockClaim,
  requestResetHistoryStore,
} from 'containers/CourtManagerLegalProceedings/actions';
import { setLockedClaim } from 'containers/LawyerLegalProceedingsPage/actions';
import { resetStoreClaim } from 'containers/RecapManagerPage/actions';
import { resetSearchClaimsStore } from 'containers/IdentificationPage/actions';
import {
  setCurrentIndexTabManager,
  setCurrentInstanceTab,
  setCurrentIndexGlobalTabManager,
  setCurrentIndexTabExpertise,
  setCurrentIndexTabJudiciaryProcessManager,
  setNotificationFeeNote,
  setCurrentRegulationPath,
  setCurrentIndexTabTransaction,
} from 'containers/AppContainer/actions';

const Container = styled.div`
  margin-top: 50px;
  padding-top: 0px;

  .title {
    text-align: left;
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: #384264;
    opacity: 1;
    padding: 10px;
  }
  .headerTitle {
    text-align: left;
    font-size: 11px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 0px;
    font-weight: Bold;
  }
  .row {
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 11px;
    color: #2b2727;
  }
  .claims {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .add-button {
    cursor: 'pointer';
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
`;

export interface ManagerPendingTreatementClaimsProps {
  intl: IntlShape;
  requestPendingTreatementClaims: Function;
  pendingTreatementClaims: any;
  countClaims: any;
  requestSearchPendingTreatementClaims: Function;
  listings: any;
  setClaimNumber: Function;
  setNotification: Function;
  setSelectedClaim: Function;
  setCurrentIndexTabManager: Function;
  setCurrentInstanceTab: Function;
  setCurrentIndexGlobalTabManager: Function;
  setCurrentIndexTabExpertise: Function;
  setCurrentIndexTabJudiciaryProcessManager: Function;
  setNotificationFeeNote: Function;
  setCurrentRegulationPath: Function;
  setTransactionId: Function;
  setCurrentIndexTabTransaction: Function;
  resetStoreClaim: Function;
  resetSearchClaimsStore: Function;
  requestResetHistoryStore: Function;
  requestUnlockClaim: Function;
  setLockedClaim: Function;
  resetSagisInfoClaim: Function;
}

export const ManagerPendingTreatementClaims: React.FC<ManagerPendingTreatementClaimsProps> = (
  props,
): JSX.Element => {
  const [page, setPage] = React.useState(0);
  const [pageSize, setRowsPerPage] = React.useState(25);

  const [searchQuery, setSearchQuery] = React.useState<any>({
    claimNumber: null,
  });

  const submitSearch = () => {
    props.requestSearchPendingTreatementClaims({
      ...searchQuery,
      isTransactionManager: userPrivileges.userHasPrivilege(
        PRIVILEGES.ISTRANSACTIONMANAGER,
      ),
    });
  };
  const isTransactionManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISTRANSACTIONMANAGER,
  );

  const handleResetStore = () => {
    props.resetSearchClaimsStore();
    props.resetSagisInfoClaim();
    props.resetStoreClaim();
    props.setNotification({});
    props.requestUnlockClaim({}, () => {
      props.setLockedClaim(null);
      props.requestResetHistoryStore();
    });
  };

  const handlerRefresh = () => {
    setSearchQuery({
      claimNumber: null,
    });
    props.requestPendingTreatementClaims({
      page,
      pageSize,
      isTransactionManager,
    });
  };

  useEffect(() => {
    props.requestPendingTreatementClaims({
      page,
      pageSize,
      isTransactionManager,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
    props.requestPendingTreatementClaims({
      page: newPage,
      pageSize,
      isTransactionManager,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const size = parseInt(event.target.value, 10);
    setRowsPerPage(size);
    props.requestPendingTreatementClaims({
      page,
      pageSize: size,
      isTransactionManager,
    });
  };

  const handleNavigateByRole = (row: any, isCicaMixte: boolean) => {
    if (userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) {
      handleResetStore();
      props.setCurrentIndexTabManager(renderLegalProceedingTab(row));
      props.setCurrentIndexGlobalTabManager(renderGlobalTab(row));
      props.setCurrentRegulationPath(renderRegulationTab(row));
      props.setCurrentInstanceTab(renderInstanceTab(get(row, 'judgement', {})));
      props.setCurrentIndexTabExpertise(renderExpertiseTab(row));
      props.setCurrentIndexTabJudiciaryProcessManager(
        get(row, 'judiciaryProcessId', null),
      );
      if (!isEmpty(get(row, 'documentImaging', null))) {
        props.setNotification(row);
      }
      if (!isNil(get(row, 'feeNoteId', null))) {
        props.setNotificationFeeNote(get(row, 'feeNote', null));
      }
      return pushTo(
        !isNil(get(row, 'feeNoteId', null))
          ? `${PAGES.MANAGER_FEE_NOTE}`
          : `${PAGES.COURT_MANAGER_LEGAL_PROCEEDINGS}/${get(row, 'claim.id')}`,
      )();
    } else if (
      !isNil(get(row, 'timelineTransaction.transactionId', null)) ||
      (userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER) &&
        isNil(get(row, 'timelineTransactionId', null)))
    ) {
      props.setTransactionId(get(row, 'transactionId', null));
      props.setCurrentIndexGlobalTabManager(renderGlobalTab(row));
      props.setCurrentIndexTabTransaction(renderTransactionTab(row));
      return pushTo(
        `${PAGES.TRANSACTION_LEGAL_PROCEDDING}/${get(row, 'claim.id')}`,
      )();
    } else if (
      userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
      !isCicaMixte
    ) {
      if (!isNil(get(row, 'feeNoteId', null))) {
        props.setNotificationFeeNote(get(row, 'feeNote', null));
      }
      return pushTo(
        !isNil(get(row, 'feeNoteId', null))
          ? `${PAGES.MANAGER_FEE_NOTE}`
          : `${PAGES.MANAGER_RECAP_PAGE}/${get(row, 'claim.id')}`,
      )();
    } else if (
      userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
      isCicaMixte
    ) {
      props.setClaimNumber(get(row, 'claimNumber', ''));
      props.setSelectedClaim(0);
      props.setNotification(row);
      return pushTo(PAGES.CONVERT_CLAIM_MANAGER_PAGE)();
    }
  };
  return (
    <Container>
      <Card>
        <CardContent>
          <div className="header">
            <CardTitle
              count={props.countClaims}
              message={translate({ ...messages.title }, props)}
            />
            <SearchBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handlerSearch={submitSearch}
              handlerRefresh={handlerRefresh}
            />
          </div>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.claimNumber }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.registrationNumber }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.lossDate }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.inboxesTitle }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {isTransactionManager
                      ? translate({ ...messages.areaTitle }, props)
                      : translate({ ...messages.taskTitle }, props)}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {get(props, 'pendingTreatementClaims', []).map((row: any) => (
                  <TableRow
                    key={row.id}
                    onClick={() =>
                      handleNavigateByRole(
                        row,
                        !isNil(get(row, 'nature', null)),
                      )
                    }
                  >
                    <TableCell align="left" className="row">
                      {!isNil(get(row, 'claim.claimNumber', null))
                        ? get(row, 'claim.claimNumber')
                        : get(row, 'claimNumber')}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {get(row, 'claim.registrationNumber')}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {!isNil(get(row, 'claim.lossDate', null))
                        ? moment(get(row, 'claim.lossDate')).format(
                            `YYYY-MM-DD - ${get(row, 'claim.lossHour')}`,
                          )
                        : '-'}
                    </TableCell>
                    <TableCell align="left" className="row">
                      <Chip
                        style={{
                          backgroundColor: COLORS.SIDE_MENU_LIGHT_BLUE,
                          color: COLORS.WHITE,
                          fontWeight: 500,
                        }}
                        label={getLabelInboxe(
                          row,
                          props.listings,
                          isTransactionManager,
                        )}
                      />
                    </TableCell>
                    <TableCell align="left" className="row">
                      <Chip
                        style={{
                          backgroundColor: COLORS.YELLOW,
                          color: COLORS.WHITE,
                          fontWeight: 500,
                        }}
                        label={getLabelSubInboxe(
                          row,
                          props.listings,
                          isTransactionManager,
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={ROW_PER_PAGE}
              component="div"
              count={props.countClaims}
              rowsPerPage={pageSize}
              page={page}
              labelRowsPerPage={translate({ ...messages.linesPerPage }, props)}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};

const mapDispatchToProps = {
  requestPendingTreatementClaims,
  requestSearchPendingTreatementClaims,
  setClaimNumber,
  setNotification,
  setSelectedClaim,
  setCurrentIndexTabManager,
  setCurrentInstanceTab,
  setCurrentIndexGlobalTabManager,
  setCurrentIndexTabExpertise,
  setCurrentIndexTabJudiciaryProcessManager,
  setNotificationFeeNote,
  setCurrentRegulationPath,
  setTransactionId,
  setCurrentIndexTabTransaction,
  setLockedClaim,
  resetStoreClaim,
  resetSearchClaimsStore,
  requestResetHistoryStore,
  requestUnlockClaim,
  resetSagisInfoClaim,
};

const mapStateToProps = createStructuredSelector({
  pendingTreatementClaims: makeSelectPendingTreatementClaims(),
  countClaims: makeSelectCountPendingTreatementClaims(),
  listings: makeSelectListings(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ManagerPendingTreatementClaims));
